import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  Card,
  CardContent,
  Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import giftTemplates from '../data/giftTemplates.json';

const GIFT_PLANS = [
  {
    id: 'gift-2-months',
    title: 'Gift 2 Months',
    duration: '2 months',
    price: 600,
    description: 'Perfect for a quick surprise',
    paymentUrl: 'https://rzp.io/rzp/youngpressogiftplan2'
  },
  {
    id: 'gift-3-months',
    title: 'Gift 3 Months',
    duration: '3 months',
    price: 900,
    description: 'A thoughtful reading treat',
    paymentUrl: 'https://rzp.io/rzp/youngpressogiftplan3'
  },
  {
    id: 'gift-4-months',
    title: 'Gift 4 Months',
    duration: '4 months',
    price: 1200,
    description: 'Extra months of YoungPresso joy',
    paymentUrl: 'https://rzp.io/rzp/youngpressogiftplan4'
  }
];

const GiftingSecured = () => {
  const navigate = useNavigate();
  // const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedPlanId, setSelectedPlanId] = useState(null);

  // const handleTemplateSelect = (templateId) => {
  //   setSelectedTemplateId(templateId);
  // };

  const handleContinueToPayment = (plan) => {
    // Template selection temporarily disabled — cards only
    // if (!selectedTemplateId) {
    //   return;
    // }

    setSelectedPlanId(plan.id);
    if (plan.paymentUrl) {
      window.open(plan.paymentUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 30%, #2a2a2a 70%, #1a1a1a 100%)'
      }}
    >
      <AppBar
        position="static"
        sx={{
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.3)'
        }}
      >
        <Toolbar>
          <IconButton
            onClick={() => navigate('/user-dashboard')}
            sx={{
              color: '#FF6B35',
              mr: 1,
              '&:hover': {
                background: 'rgba(255, 107, 53, 0.1)'
              }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <MenuBookIcon sx={{ color: '#FF6B35', mr: 2, fontSize: 32 }} />
          <Typography
            variant="h6"
            component="div"
            onClick={() => navigate('/user-dashboard')}
            sx={{
              flexGrow: 1,
              fontWeight: 700,
              cursor: 'pointer',
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              '&:hover': {
                opacity: 0.85
              }
            }}
          >
            Subscriber Zone
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: { xs: 3, sm: 4, md: 5 } }}>
        <Box sx={{ textAlign: 'center', mb: { xs: 3, sm: 4 } }}>
          <CardGiftcardIcon sx={{ fontSize: { xs: 48, sm: 56 }, color: '#FF6B35', mb: 1 }} />
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.4rem' }
            }}
          >
            Gift YoungPresso
          </Typography>
        </Box>

        {/* Step 1: Template picker — temporarily commented out
        <Box sx={{ mb: { xs: 4, sm: 5 } }}>
          <Typography
            variant="h5"
            sx={{
              color: 'white',
              fontWeight: 700,
              mb: 0.5,
              fontSize: { xs: '1.2rem', sm: '1.4rem' }
            }}
          >
            Choose a gift template
          </Typography>
          <Typography
            sx={{
              color: 'rgba(255, 255, 255, 0.65)',
              mb: 2.5,
              fontSize: { xs: '0.85rem', sm: '0.95rem' }
            }}
          >
            This design will be used for the gift plan you pick below.
          </Typography>

          {!selectedTemplateId ? (
            <Typography
              sx={{
                color: 'rgba(255, 255, 255, 0.5)',
                mb: 2,
                fontSize: { xs: '0.85rem', sm: '0.9rem' }
              }}
            >
              Pick a template first to unlock Continue to payment
            </Typography>
          ) : null}

          <Grid container spacing={{ xs: 1.5, sm: 2 }}>
            {giftTemplates.map((template) => {
              const isSelected = selectedTemplateId === template.id;
              return (
                <Grid item xs={6} sm={4} md={2.4} key={template.id}>
                  <Box
                    role="button"
                    tabIndex={0}
                    aria-pressed={isSelected}
                    aria-label={`Select ${template.name}`}
                    onClick={() => handleTemplateSelect(template.id)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleTemplateSelect(template.id);
                      }
                    }}
                    sx={{
                      position: 'relative',
                      cursor: 'pointer',
                      borderRadius: 2,
                      overflow: 'hidden',
                      border: isSelected
                        ? '3px solid #FF6B35'
                        : '3px solid rgba(255, 255, 255, 0.12)',
                      boxShadow: isSelected
                        ? '0 0 0 2px rgba(255, 183, 77, 0.35)'
                        : 'none',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderColor: 'rgba(255, 107, 53, 0.7)',
                        transform: 'translateY(-2px)'
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src={template.image}
                      alt={template.name}
                      sx={{
                        width: '100%',
                        aspectRatio: '1 / 1',
                        objectFit: 'cover',
                        display: 'block'
                      }}
                    />
                    {isSelected && (
                      <Box
                        sx={{
                          position: 'absolute',
                          inset: 0,
                          background: 'rgba(255, 107, 53, 0.25)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <CheckCircleIcon sx={{ color: '#FFB74D', fontSize: 36 }} />
                      </Box>
                    )}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
        */}

        {/* Gift banner */}
        <Box
          sx={{
            mb: { xs: 3, sm: 4 },
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Box
            component="img"
            src="https://dp9h3awfnhccl.cloudfront.net/public_folder/gift-banner.jpeg"
            alt="Pick a Subscription Gift"
            sx={{
              width: '50%',
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
              borderRadius: { xs: 2, sm: 3 }
            }}
          />
        </Box>

        {/* Plan cards */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              color: 'white',
              fontWeight: 700,
              mb: 0.5,
              fontSize: { xs: '1.2rem', sm: '1.4rem' }
            }}
          >
            Choose a gift plan
          </Typography>
          <Typography
            sx={{
              color: 'rgba(255, 255, 255, 0.65)',
              mb: 2.5,
              fontSize: { xs: '0.85rem', sm: '0.95rem' }
            }}
          >
            Select how long you want to gift YoungPresso.
          </Typography>

          <Grid container spacing={{ xs: 2, sm: 3 }}>
            {GIFT_PLANS.map((plan) => {
              const isPlanSelected = selectedPlanId === plan.id;
              return (
                <Grid item xs={12} sm={4} key={plan.id}>
                  <Card
                    sx={{
                      height: '100%',
                      background: 'rgba(255, 255, 255, 0.05)',
                      backdropFilter: 'blur(10px)',
                      border: isPlanSelected
                        ? '2px solid rgba(255, 107, 53, 0.7)'
                        : '2px solid rgba(255, 255, 255, 0.1)',
                      borderRadius: 3,
                      transition: 'all 0.25s ease',
                      '&:hover': {
                        borderColor: 'rgba(255, 107, 53, 0.5)',
                        boxShadow: '0 8px 28px rgba(255, 107, 53, 0.2)'
                      }
                    }}
                  >
                    <CardContent
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: 1,
                        height: '100%'
                      }}
                    >
                      <Typography
                        sx={{
                          color: '#FFB74D',
                          fontWeight: 700,
                          fontSize: { xs: '1rem', sm: '1.1rem' }
                        }}
                      >
                        {plan.duration}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'white',
                          fontWeight: 800,
                          fontSize: { xs: '2rem', sm: '2.2rem' },
                          lineHeight: 1.1
                        }}
                      >
                        ₹{plan.price}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'rgba(255, 255, 255, 0.6)',
                          fontSize: { xs: '0.85rem', sm: '0.9rem' },
                          mb: 1.5,
                          flexGrow: 1
                        }}
                      >
                        {plan.description}
                      </Typography>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleContinueToPayment(plan)}
                        sx={{
                          background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
                          color: 'white',
                          fontWeight: 700,
                          textTransform: 'none',
                          py: 1.1,
                          '&:hover': {
                            background: 'linear-gradient(45deg, #FF8C35 30%, #FFC74D 70%)',
                            boxShadow: '0 6px 20px rgba(255, 107, 53, 0.45)'
                          }
                        }}
                      >
                        Add Details and Pay
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default GiftingSecured;
